import React from 'react';
import Form from 'react-bootstrap/Form';
import { Colors } from '_styles';

const Label = (props) => {
    return (
        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{props.children}</Form.Label>
    );
};

export default Label;
